export enum RoleAction {
  // Incident Permission Actions
  CREATE_INCIDENT = "CREATE_INCIDENT",
  EDIT_INCIDENT = "EDIT_INCIDENT",
  CLOSE_INCIDENT = "CLOSE_INCIDENT",
  DELETE_INCIDENT = "DELETE_INCIDENT",
  ADD_NOTE = "ADD_NOTE",

  // Mobility Strategies Permission Actions
  ADD_AND_EDIT_MODBILITY_STRATEGIES = "ADD_AND_EDIT_MODBILITY_STRATEGIES",

  // PIO Permission Actions
  ADD_EDIT_TALKING_POINTS = "ADD_EDIT_TALKING_POINTS",
  ADD_EDIT_SCHEDULED_OUTREACH = "ADD_EDIT_SCHEDULED_OUTREACH",

  // Records Management Permission Actions
  VIEW_RECORDS_MGMT = "VIEW_RECORDS_MGMT",

  // Agency Admin Permission Actions
  VIEW_USER_ADMIN = "VIEW_USER_ADMIN",

  // Site Admin Permission Actions
  VIEW_AGENCY_ADMIN = "VIEW_AGENCY_ADMIN",

  // Major Construction & Events Permission Actions
  CREATE_MAJOR_EVENTS = "CREATE_MAJOR_EVENTS",
  DELETE_MAJOR_EVENTS = "DELETE_MAJOR_EVENTS",
  EDIT_MAJOR_EVENTS = "EDIT_MAJOR_EVENTS",
  VIEW_MAJOR_EVENTS = "VIEW_MAJOR_EVENTS",
}
